import React, { useEffect, useState, useMemo } from "react";
import { MdAddCircleOutline } from "react-icons/md";
import SpecialSubjectContentTr from "./SpecialSubjectContentTr";
import EmptySpecialSubjectContentTr from "./EmptySpecialSubjectContentTr";
import { useTranslation } from "react-i18next";
import { arrangeDataByHierarchy } from "../../../../util/specialCase";

export default function SpecialSubjectContentTable({ items, setItems }) {
  const [rows, setRows] = useState([]);
  const { t } = useTranslation();

  const [hideAddBtn, setHideAddBtn] = useState(false);
  const [isAddingRow, setIsAddingRow] = useState(false);

  // 계층 구조로 정렬된 데이터
  const sortedItems = useMemo(() => {
    if (!Array.isArray(items) || items.length === 0) return [];
    return arrangeDataByHierarchy([...items]);
  }, [items]);

  useEffect(() => {
    if (sortedItems) {
      setRows(sortedItems);
    }
  }, [sortedItems]);

  const handleAddClick = () => {
    setHideAddBtn(true);
    setIsAddingRow(true);
  };

  return (
    <div className="mt-3">
      <table className="table text-center align-middle p-0 m-0">
        <thead>
          <tr>
            <th scope="col" className="ps-0 pe-0" style={{ width: "40px" }}>
              {t("teacher.lessonRelated.level") || "단계"}
            </th>
            <th scope="col" className="ps-0 pe-0" style={{ width: "200px" }}>
              {t("teacher.lessonRelated.area") || "최상위/영역"}
            </th>
            <th scope="col">{t("teacher.lessonRelated.content") || "내용"}</th>
            <th scope="col" className="ps-0 pe-0" style={{ width: "60px" }}>
              {t("common.labels.order") || "순서"}
            </th>
            <th
              scope="col"
              className="ps-0 pe-0 pb-1"
              style={{ width: "60px" }}
            >
              {t("common.labels.add") || "추가"}
              {!hideAddBtn && (
                <MdAddCircleOutline
                  className="p-0 mb-1"
                  role="button"
                  size={25}
                  color="blue"
                  onClick={handleAddClick}
                />
              )}
            </th>
            <th scope="col" className="ps-0 pe-0" style={{ width: "115px" }}>
              {t("common.labels.save_delete") || "저장/삭제"}
            </th>
          </tr>
          {isAddingRow && (
            <EmptySpecialSubjectContentTr
              setHideAddBtn={setHideAddBtn}
              setIsAddingRow={setIsAddingRow}
              parentId={0}
              parentHierarchyLevel={0}
              items={items}
              setItems={setItems}
              setRows={setRows}
            />
          )}
        </thead>
        <tbody>
          {sortedItems?.length > 0 &&
            rows?.length > 0 &&
            rows.map(
              (item) =>
                item.hierarchy_level !== 0 && (
                  <SpecialSubjectContentTr
                    key={item.id}
                    item={item}
                    hideAddBtn={hideAddBtn}
                    setHideAddBtn={setHideAddBtn}
                    items={items}
                    setRows={setRows}
                    setItems={setItems}
                  />
                )
            )}
        </tbody>
      </table>
    </div>
  );
}
